export default function BottomSheetHeader({ title, subtitle, onClose }) {
  return (
    <div className="sticky top-0 bg-white border-b border-secondary-200 px-4 py-3 z-10">
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-semibold text-secondary-900 truncate">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-secondary-600 truncate mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-4 p-2 hover:bg-secondary-100 rounded-lg transition-colors touch-target flex-shrink-0"
            aria-label="Close"
          >
            <svg className="w-5 h-5 text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}
